import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconAddComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Add${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 17 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M8.08667 13.5385C8.08667 13.7934 8.31053 14 8.58667 14C8.86281 14 9.08667 13.7934 9.08667 13.5385V8.53846H14.087C14.3419 8.53846 14.5486 8.3146 14.5486 8.03846C14.5486 7.76232 14.3419 7.53846 14.087 7.53846H9.08667V2.46154C9.08667 2.20664 8.86281 2 8.58667 2C8.31053 2 8.08667 2.20664 8.08667 2.46154V7.53846H3.01012C2.75522 7.53846 2.54858 7.76232 2.54858 8.03846C2.54858 8.3146 2.75522 8.53846 3.01012 8.53846H8.08667V13.5385Z"/></svg>;
}

const IconAdd = React.forwardRef(IconAddComponent);
export default IconAdd;
